<script setup>
import {getLogo} from "@/helpers/logo";
import {computed, toRefs} from "vue";
import StartupTrackersWidget from "@/components/startups/StartupTrackersWidget.vue";
import {useStore} from "vue2-helpers/vuex";

const props = defineProps(['startup', 'isSelected']);
const {startup, isSelected} = toRefs(props);

const emit = defineEmits(['setSelected']);
const store = useStore();

const selected = computed({
    get: function () {
        return isSelected.value;
    },
    set: function (value) {
        emit("setSelected", value)
    }
});

const scoreLabel = computed(() => {
    if (startup.value.score > 50) {
        return 'High';
    } else if (startup.value.score < 30) {
        return 'Low';
    } else {
        return 'Medium';
    }
});
</script>

<template>
    <tr>
        <td class="main-table__check">
            <div class="input-checkbox">
                <input :id="'t' + startup.id" type="checkbox" v-model="selected">
                <label :for="'t' + startup.id"></label>
            </div>
        </td>

        <td>
            <div class="main-table__data">
                <div class="image-block">
                    <img :src="getLogo(startup.image)" alt="">
                </div>
                <div class="pr-3">
                    <h5 class="heading5">
                        <a :href="'/startups/' + startup.id" target="_blank">{{startup.name}}</a>
                    </h5>
                    <div>
                        <span class="line-clamp">{{startup.description}}</span>
                    </div>
                </div>

                <StartupTrackersWidget
                    v-if="store.getters.isEnterprise"
                    :startupId="startup.id"
                    :trackersCount="startup.trackersCount"
                />
            </div>
        </td>

        <td v-if="'score' in startup">{{scoreLabel}}</td>
        <td>{{startup.categories}}</td>
    </tr>
</template>

<style scoped>

</style>
